import React from "react";

interface Props {
    children: React.ReactNode;
}

const TableHeader = ({ children }: Props) => <thead>{children}</thead>;

export default TableHeader;
